// src/app/services/clientOrderService.ts
import { listSalesOrders } from './salesOrderService';
import { SalesOrderSource } from '@/app/types/salesOrder';

/**
 * Count of app-initiated sales orders still in draft (i.e. submitted from the
 * customer or sales-manager PWA but not yet converted to an invoice), for one
 * creation channel.
 *
 * Reuses the sales-orders list endpoint with limit=1 and reads the `total`
 * field (the full filtered count before pagination) — the same trick used by
 * deliveryStatusService. No dedicated backend endpoint required.
 */
export const fetchDraftOrderCountBySource = async (
  source: SalesOrderSource
): Promise<number> => {
  try {
    const filters = JSON.stringify([
      { field: 'order_source', value: source, op: 'eq' },
      { field: 'status', value: 'draft', op: 'eq' },
    ]);
    const res = await listSalesOrders({ limit: 1, filters });
    return res.total || 0;
  } catch (error) {
    console.error(`Error fetching ${source} draft order count:`, error);
    return 0;
  }
};
